import React from 'react';
import loadable from '@loadable/component';

const CancelReasonsContainer = loadable(() =>
  import('features/Settings/Membership/Update/Cancel/reasons/CancelReasonsContainer')
);
const CancelStepContainer = loadable(() =>
  import('features/Settings/Membership/Update/Cancel/step/CancelStepContainer')
);

export const CancelRoute = () => ({
  path: 'settings/membership/update/cancel',
  childRoutes: [
    {
      path: 'reasons(/:cancelReasonCode)',
      component: props => <CancelReasonsContainer {...props} />,
    },
    {
      path: 'steps/:stepId',
      component: props => <CancelStepContainer {...props} />,
    },
  ],
});
